<template>
    <DCard
        padding
    >
        <Form
            :accounting-product="accountingProduct"
            :errors="errors"
            :is-finance-system-netsuite="isFinanceSystemNetsuite"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/AccountingProduct/Form'

export default {
    name: 'AccountingProductUpdate',
    components: {
        Form
    },
    props: {
        accountingProduct: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    methods: {
        submitData (form) {
            form.put(this.$route('settings.accounting-products.update', this.accountingProduct.id))
        }
    }
}
</script>
